import { useEffect, useRef, useState } from "react";
import "./message.scss";
import Dialog from "@mui/material/Dialog";
import Skeleton from "@mui/material/Skeleton";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

const Message = ({ message }) => {
  const ref = useRef();
  const now = new Date();
  const date = new Date(message.datetime);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [imgSource, setImgSource] = useState("");
  const isUrl = word => {
    const urlPattern = /(http(s)?:\/\/[^\s]+)/gi;
    return word.match(urlPattern);
  };
  const [loading, setLoading] = useState(true);

  const time =
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0");

  const days = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

  const fullDate =
    date.getDate().toString().padStart(2, "0") +
    "." +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "." +
    date.getFullYear();

  const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  const oneWeekPassed = oneWeekAgo >= date;

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, []);

  const addMarkup = word => {
    return isUrl(word)
      ? `<a class="link" href="${word}" target="_blank">${word}</a>`
      : word;
  };

  const words = message?.message.split(" ");
  const formatedWords = words.map(w => addMarkup(w));
  const html = formatedWords.join(" ");

  return (
    <div
      className={`message ${message.author === "owner" && "owner"}`}
      ref={ref}
    >
      <div className="messageContent">
        <div
          className="mess"
          style={
            message.message === "" && message.files.length !== 0
              ? { display: "none" }
              : { display: "flex" }
          }
        >
          {/* <p dangerouslySetInnerHTML={{ __html: html }}></p> */}

          <div className="messageText">
            <ReactMarkdown
              remarkPlugins={[remarkBreaks]}
              components={{
                a: ({ children, ...props }) => (
                  <a
                    {...props}
                    className="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {children}
                  </a>
                )
              }}
            >
              {message?.message || ""}
            </ReactMarkdown>
          </div>

          {message.edited === 1 && <span className="edited">изменено</span>}

          <span className="date">
            {oneWeekPassed
              ? fullDate
              : time +
                " " +
                (date.getDate() >= now.getDate() &&
                date.getMonth() >= now.getMonth()
                  ? ""
                  : days[date.getDay()])}
          </span>
        </div>

        {message.files &&
          message.files.map((file, i) => (
            <div className="dateT" key={i}>
              {loading ? (
                <Skeleton sx={{ width: "200px", height: "150px" }} />
              ) : (
                <img
                  src={file}
                  alt="img"
                  onClick={() => {
                    setImgSource(file);
                    handleOpen();
                  }}
                />
              )}

              <div className="imgBlock">
                {oneWeekPassed
                  ? fullDate
                  : time +
                    " " +
                    (date.getDate() >= now.getDate()
                      ? ""
                      : days[date.getDay()])}
              </div>
            </div>
          ))}
      </div>

      <Dialog open={open} onClose={handleClose}>
        <img src={imgSource} alt="" />
      </Dialog>
    </div>
  );
};

export default Message;
